import React from "react";
import clsx from "clsx";

export interface RadioButtonV2Props {
  id: string;
  label: string;
  name: string;
  value: string;
  checked: boolean;
  onClick: (value: string) => void;
  disable?: boolean;
  className?: string;
  blokClassName?: string;
  key?: string;
  data_testid?: string;
}

  export function RadioButtonV2({ id, label, value, name, checked, disable, onClick, className, data_testid, blokClassName, key }: RadioButtonV2Props) {
  const buttonCLasses = clsx({
    "checkbox appearance-none dark:ring-offset-gray-900 group-checked:text-primary checked:opacity-100 ring-2 mr-3 ring-offset-2 ring-gray-500 checked:ring-primary bg-white dark:bg-gray-900 checked:bg-primary dark:checked:bg-primary rounded-full cursor-pointer w-3 h-3":
      true
  });
  const labelClasses = clsx({
    "cursor-pointer group-checked:text-white": true,
    "text-gray-500": !checked
  });

  return (
    <div className={`flex group radioButton items-center ${className} ${blokClassName}`} aria-label="Radio Button" key={key}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onClick={(e) => onClick(value)}
        className={buttonCLasses}
        aria-label={label} 
        disabled={disable}
        data-testid={data_testid}
      />
      <label id={`label_${id}`} htmlFor={id} className={labelClasses} aria-label={name}>
        {label}
      </label>
    </div>
  );
}
